import { render, staticRenderFns } from "./CheckoutEmail.vue?vue&type=template&id=3b5b3803&"
import script from "./CheckoutEmail.vue?vue&type=script&lang=js&"
export * from "./CheckoutEmail.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutEmail.vue?vue&type=style&index=0&id=3b5b3803&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports